import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import GroupAvatar from '../GroupAvatar';

const SessionChatStreamHeader = ({ title, subtitle, className, initials, ...props }) => {
  const cn = useClassNames(
    () => [
      'flex',
      'flex-col',
      'justify-center',
      'text-center',
      'max-w-line-length',
      'py-8',
      'mx-auto',
      className,
    ],
    [className],
  );
  return (
    <header data-component="SessionChatStreamHeader" className={cn} {...props}>
      <GroupAvatar alt={`Gruppenicon für ${title}`} initials={initials} size="32" />
      <h1 className="text-2xl font-semibold mt-8 mb-3">{title}</h1>
      {subtitle && <div>{subtitle}</div>}
    </header>
  );
};

SessionChatStreamHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  initials: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

SessionChatStreamHeader.defaultProps = {
  title: null,
  subtitle: null,
};

export default SessionChatStreamHeader;
